module.exports = __webpack_public_path__ + "img/folder.0ddba6e1.svg";